export default __webpack_public_path__ + "static/media/Long Pink.aefe6db3.png";